import React from "react";
import styles from "./RedeemCard.module.css";
import Paragraph, { ParagraphSize } from "../../../components/Paragraph";
import ImageComponent from "../../../components/ImageComponent";
import clsx from "clsx";

interface RedeemCard {
  isHovered: boolean;
  tagName: string;
  title: string;
  description: string;
  image: string;
}

const RedeemCard: React.FC<RedeemCard> = ({
  isHovered,
  tagName,
  title,
  description,
  image,
}) => {
  return (
    <div className={styles["main-container"]}>
      <div className={styles["card-wrapper"]}>
        <div className={clsx(styles["tab"], isHovered && styles["tab-active"])}>
          <Paragraph
            size={ParagraphSize.paragraph2}
            classNameStyle={clsx(
              isHovered ? styles["share-text"] : styles["white-text"]
            )}
          >
            {tagName}
          </Paragraph>
        </div>
        <div
          className={clsx(
            styles["card-container"],
            isHovered && styles["card-container-active"]
          )}
        >
          <div className={styles["info-container"]}>
            <Paragraph
              size={ParagraphSize.paragraph1}
              classNameStyle={styles["white-text"]}
            >
              {title}
            </Paragraph>
            <Paragraph
              size={ParagraphSize.paragraph2}
              classNameStyle={styles["remove-margin-text"]}
            >
              {description}
            </Paragraph>
          </div>
          <div className={styles["image-container"]}>
            <ImageComponent src={image} className={styles["image-view"]} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default RedeemCard;
